import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAquaaAdminQuestionsTableData, getAquaaQuestionAssessmentsData, updateAquaaAdminQuestionsDataStart } from '../../../../actions/Applications/aquaa.action';
import { AssignedAccountsTblPopUp } from '../../../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels';
import editIcon from './../../../../assets/onboard-images/Edit_Icon.png'
import searchIcon from './../../../../assets/onboard-images/Search_Icon.png';
import { useHistory } from 'react-router-dom';
import MultipleSelectChip from '../../../Reusable components/MultiselectwithSearch';
import AdminBreadcrumb from '../../../../components/Administration/General/Admin-breadcrumb';

const AquaaAdminQuestions = () => {
      const dispatch = useDispatch();
      const history = useHistory();
       const aquaaQuestionAssessmentsData = useSelector((state) => state.aquaaReducer.aquaaQuestionAssessmentsData);
       const aquaaAdminQuestionsTableData = useSelector((state) => state.aquaaReducer.aquaaAdminQuestionsTableData);
      
          const [selectedAssessment, setSelectedAssessment] = useState(); 
          const [model, setModel] = useState(false)
          const [mode, setMode] = useState('') 
          const [filter, setFilter] = useState('');
          let searchColumns = ['Question'];
          const [formData, setFormData] = useState({
              contactTypeForm: '',
              description:''

            });
        
           useEffect(()=> {
                  dispatch(getAquaaQuestionAssessmentsData());
               dispatch(getAquaaAdminQuestionsTableData());
                 }, [dispatch]);
    
                 const handleFormDataChange = (key, value) => {
        setFormData((prevData) => ({
          ...prevData,
          [key]: value, // Update specific key in formData
        }));
      };
    
       const handleAddAccount = async () => {
    
        
    
        // // Fetch the updated data
        // dispatch(getAquaaAdminQuestionsTableData());
    setModel(true);
    setMode('add')
      };
    
    const columns = aquaaAdminQuestionsTableData && aquaaAdminQuestionsTableData.length > 0 ? Object.keys(aquaaAdminQuestionsTableData[0]) : [];
    
    const data = aquaaAdminQuestionsTableData

    const handleRecommendationsChange = (newSelection) => {
    setSelectedAssessment(newSelection);
  };
const arrayToCommaSeparatedString = (array) => {
    return array.map(value => `${value}`).join(', ');
  };

  function searchRows(rows) {
  return rows.filter((row) =>
    searchColumns.some((column) =>
      (row[column] ?? '').toString().toLowerCase().includes(filter.toLowerCase())
    )
  );
}
    console.log('setSelectedAssessment',selectedAssessment)
  return (
     <section>
           <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={true}
        value3={() => history.push('/aquaaadminonboardlanding')} label3='AQuAA Admin' isActive4={false} label4='Questions'/>
             <section className="App_Layout" style={{ marginBottom: '20px' }}>
               <div className="Applications_Title"> Questions </div>
             </section>
                <section className='App_Layout'>
              <main className='Title_bar'>
              <div> <span className='search_bar_AdminFlow'>
                          <input className='search_input_AdminFlow' value={filter || ''} onChange={e => setFilter(e.target.value)} placeholder='Search Questions' />
                          <button className='search_icon_AdminFlow'><img src={searchIcon} alt='' /> </button>
                        </span></div>
              <div className='btn_adduser' onClick={handleAddAccount}>Add</div>
              </main>
             </section>
              <br/> <br/> 
         <table className="aquaa-table">
      <thead>
        <tr>
          {columns.map((col, index) => (
            <th key={index}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data && data.length > 0 ? (
         searchRows(data).map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => {
                const cellData = row[col]; // row['account_Name']

                 if (col === 'Assessments' && Array.isArray(cellData)) {
    return (
     <> <td key={colIndex}>
        {cellData.map((a, i) => (
          <div key={i}>{a.Assessment}</div>
        ))}
      </td>
       <td onClick={()=>{setModel(true);setMode('edit');setFormData({
              contactTypeForm: row['Question'] || '',
              description: row['Description'] || '',
             
            });
            if (row['Assessments'] && Array.isArray(row['Assessments'])) {
              setSelectedAssessment(row['Assessments'].map(a => a.Assessment));
            } else {
              setSelectedAssessment([]);
            }
          }}> <img src={editIcon} alt='edit' /></td></>
    );
  }


                return <td key={colIndex}>{cellData}</td>
               
              })}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length}>
              <section>
                <div className="noData-para" style={{ marginTop: 0 }}>
                  <div style={{ marginTop: 30 }}>
                    No data available, please try different filters or contact the admin
                  </div>
                </div>
              </section>
            </td>
          </tr>
        )}
      </tbody>
    </table>

        {model &&
              <AssignedAccountsTblPopUp isOpen={model} setShowModal={setModel}>
             {mode === 'add' ? <><div>
                <div><label>Questions</label></div>
                <input
                  type="text"
                  placeholder="Example: 0123456789"
                  value={formData.contactTypeForm}
                  onChange={(e) => handleFormDataChange('contactTypeForm', e.target.value)}  // Bind to formData.ticketNumber
                />
              </div> <br/> </>: '' }
               <><div >
                <div><label>Description</label></div>
                <input
                  type="text"
                  placeholder="Example: 0123456789"
                  value={formData.description}
                  onChange={(e) => handleFormDataChange('description', e.target.value)}  // Bind to formData.ticketNumber
                />
              </div><br/></>
             {mode === 'add' ?<> <label>Assessments</label>
                    <MultipleSelectChip
                      options={aquaaQuestionAssessmentsData.map(item => item.assessment)}
                      label="Assessments"
                      value={selectedAssessment}
                      onChange={handleRecommendationsChange}
                      searchEnabled={false}
                      placeholder="Search Recommendations"
                    /></>: ''}
                       <div className='btn_adduser' onClick={()=>{dispatch(updateAquaaAdminQuestionsDataStart([{ Question: formData.contactTypeForm, Description: formData.description,Assessment: arrayToCommaSeparatedString(selectedAssessment) }]));dispatch(getAquaaAdminQuestionsTableData());setModel(false);dispatch(getAquaaAdminQuestionsTableData());}}>Add</div>
              </AssignedAccountsTblPopUp>
             }
             </section>

  )
}

export default AquaaAdminQuestions